import React from 'react';
import {OrbitComponent} from '../../base-components/orbit-component/orbit-component';
import {observer} from 'mobx-react';
import {Link} from '../../raw-components/link/link';
import {GamblingWarningBox} from "./boxes/gambling-warning.box";

export const GamblingWarningComponent = observer(class GamblingWarningComponent extends OrbitComponent<{}> {

  render() {
    let gamblingMessageConfig = this.services.configuration.data.header.gambling_message;
    if(!gamblingMessageConfig || !gamblingMessageConfig.display) {
      return null;
    }

    return (
      <GamblingWarningBox className={"cy-gambling-warning"}>
        {this.services.translation.translate('GAMBLING_WARNING_part1')}
        <Link href={'https://www.adm.gov.it/portale/monopoli/giochi/probabilita-vincita'} preventDefaultOnClick={false} target={'_blank'}>
          {'Probabilità di vincita'}
        </Link>
        {this.services.translation.translate('GAMBLING_WARNING_part2')}
        <Link href={'https://www.888casino.it/come-iniziare/rtp/'} preventDefaultOnClick={false} target={'_blank'}>
          {'maggiori informazioni.'}
        </Link>
      </GamblingWarningBox>
    );

  }
});
